/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：473
 */

module.exports = {
  soundLayout: "style_soundLayout__1gSNJ",
  soundLayoutMain: "style_soundLayoutMain__1fBSa",
  imageLayoutList: "style_imageLayoutList__3MG7Z",
  uploadItem: "style_uploadItem__V1x0a",
  content: "style_content__JkmSN",
  icon: "style_icon__arXe1",
  name: "style_name__1Ly3n",
  SoundDragContainer: "style_SoundDragContainer__3kwW-",
  SoundLayoutEmpty: "style_SoundLayoutEmpty__OS6qn",
  emptyContent: "style_emptyContent__1kRDs",
  isDragging: "style_isDragging__nY_3M"
}
